import posthog from "posthog-js"
import { PostHogProvider } from "posthog-js/react"
import { useEffect } from "react"
import { useLocation } from "react-router-dom"
import {
	captureMetaAdsEvent,
	META_ADS_EVENTS,
	shouldCaptureMetaAdsPageView,
} from "../../utils/posthogMetaAds.js"

if (typeof window !== "undefined") {
	const posthogKey = import.meta.env.VITE_POSTHOG_KEY
	const posthogHost = import.meta.env.VITE_POSTHOG_HOST || "/ph"
	const posthogUiHost =
		import.meta.env.VITE_POSTHOG_UI_HOST || "https://eu.posthog.com"

	// If key not set, keep PostHog disabled (no accidental traffic to old instance).
	if (posthogKey) {
		posthog.init(posthogKey, {
			api_host: posthogHost,
			ui_host: posthogUiHost,
			capture_dead_clicks: false,
			capture_pageview: false,
			autocapture: false,
			disable_session_recording: true,
			enable_heatmaps: false,
			advanced_disable_flags: false,
			disable_product_tours: true,
			disable_surveys: true,
			disable_surveys_automatic_display: true,
			disable_conversations: true,
			disable_external_dependency_loading: true,
		})
		// posthog.featureFlags.overrideFeatureFlags({
		// 	flags: { "no-customize-plan-for-paid-traffic": "no-customize" },
		// })
	}
}

export const PosthogProvider = ({ children }) => {
	return <PostHogProvider client={posthog}>{children}</PostHogProvider>
}

export const PostHogPageView = () => {
	let location = useLocation()

	// Track pageviews
	useEffect(() => {
		if (posthog?.__loaded) {
			posthog.capture("$pageview", {
				$current_url: window.location.href,
			})

			if (shouldCaptureMetaAdsPageView()) {
				captureMetaAdsEvent(posthog, META_ADS_EVENTS.PAGE_VIEW)
			}
		}
	}, [location])

	return null
}
